import { gql } from '@apollo/client';

export const GET_BASE_SOURCE_PARTNERS = gql`
    query getBaseSourcePartners {
        baseSourcePartners {
            id
            name
            displayName
            logoPath
            options
        }
    }
`;

export const GET_ALL_EVENTS = gql`
    query getAllEvents {
        events {
            eventName
            displayName
            revenueEvent
            siteId
            appName
            platform
        }
    }
`;


